import { useState } from 'react';
import { Box, CssBaseline, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import Navbar from '../../redux/containers/navbar/Navbar';
import SideMenu from '../../redux/containers/navbar/SideMenu';

// Color palette que coincide con los KPI cards y la tabla
const COLORS = {
  primary: '#2196f3',
  success: '#4caf50',
  warning: '#ffc107',
  purple: '#673ab7',
  background: '#f7f9fc',
  lightBorder: '#e3f2fd',
};

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  backgroundColor: COLORS.background,
  minHeight: '100vh',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const Layout = (props) => {
  const [open, setOpen] = useState(false);

  const handleDrawer = () => {
    setOpen(!open);
  };

  return (
    
      <Box sx={{ display: 'flex', backgroundColor: COLORS.background }}>
        <CssBaseline />
        <Navbar open={open} handleDrawer={handleDrawer} />
        <SideMenu
        open={open}
        handleDrawer={handleDrawer}
        DrawerHeader={DrawerHeader}
      />
      <MainContent>
        <DrawerHeader />
          <Outlet />
      </MainContent>
    </Box>
  );
};

export default Layout;
